// We store the timer here so we can clear it whenever a new flash message
// is created, otherwise if messages are stacked then the older timeout
// will remove the newer message and the later timeout will raise an error.
let flashTimeout;

function removeFlashMessage() {
    const flash = document.querySelector("div.flash");
    if (flash) { flash.remove(); }
}

function createFlashMessage(type, message) {
    const content = document.getElementById("content");
    if (!content) { return; }

    removeFlashMessage();

    const outerDiv = document.createElement("div");
    const div = document.createElement("div");
    outerDiv.className = "flash";
    div.className = `flash-message flash-${type}`;
    div.innerHTML = message;

    outerDiv.appendChild(div);
    content.appendChild(outerDiv);

    clearTimeout(flashTimeout);
    flashTimeout = setTimeout(removeFlashMessage, 5000);
}

export function flashError(message) {
    createFlashMessage("error", message);
}

export function flashSuccess(message) {
    createFlashMessage("success", message);
}
